import LodgeClaim from "./LogdgeClaim";


export default function SearchToClaimComponent(){
    return(
        <div>
          <LodgeClaim />
        </div>
    )
}